export * from './Text';
export {TEXT_VARIANTS, text} from './text/text';
export {TEXT_COLORS, colorText} from './colorText/colorText';
